module.exports = __webpack_public_path__ + "img/srtzh.4a1755b2.png";